var CommonComparatorTableWithI18n, DbHelper, NMAExportService, NmaTablePrintout, TableSettingsContext, W, alt, createPrintoutContainer, exportToFile, gdtDataToNmaData, getOrganizationName, lift, mapConfigObject, mediator, nmaDataToVizData, printout_template, removeHTMLNode, _ref, _ref1;

alt = require('alt');

DbHelper = require('base/lib/db_helper');

mediator = require('mediator');

W = require('when');

lift = require('when/function').lift;

printout_template = require('views/templates/printouts/nma');

_ref = require('lib/nma_helper'), gdtDataToNmaData = _ref.gdtDataToNmaData, nmaDataToVizData = _ref.nmaDataToVizData;

getOrganizationName = require('lib/app_utils').getOrganizationName;

exportToFile = require('lib/export_to_file').exportToFile;

_ref1 = require('base/lib/utils'), removeHTMLNode = _ref1.removeHTMLNode, createPrintoutContainer = _ref1.createPrintoutContainer;

CommonComparatorTableWithI18n = NmaComponents.CommonComparatorTableWithI18n, TableSettingsContext = NmaComponents.TableSettingsContext;

NmaTablePrintout = require('components/nma/nma_table_printout');

mapConfigObject = function(props) {
  return _.chain(props).pairs().map(function(_arg) {
    var key, value;
    key = _arg[0], value = _arg[1];
    return ["initial" + (_.str.capitalize(key)), value];
  }).object().value();
};

module.exports = NMAExportService = (function() {
  function NMAExportService(adapter) {
    this.adapter = adapter;
  }

  NMAExportService.prototype._getNmaDataForPresentations = function(question, outcomes) {
    return gdtDataToNmaData(question, outcomes);
  };

  NMAExportService.prototype.exportToLink = function() {
    var data, organizationName, outcomes, question, tableId, vizConfig;
    question = alt.stores.NMAVizStore.getQuestion();
    outcomes = alt.stores.NMAVizStore.getOutcomes();
    vizConfig = mapConfigObject(alt.stores.NMAVizStore.getVizConfig().toJS());
    data = this._getNmaDataForPresentations(question, outcomes);
    tableId = "" + (question.get('_id')) + "-" + ((new Date()).getTime());
    organizationName = getOrganizationName();
    return this.adapter.updateOrCreate(DbHelper.getNmaDbUrl(), tableId, function(doc) {
      return _.extend({}, doc, {
        _id: tableId,
        data: data,
        organizationName: organizationName,
        vizConfig: vizConfig
      });
    }).then(function() {
      return DbHelper.getNmaUrl(tableId);
    });
  };

  NMAExportService.prototype.exportToIframe = function() {
    return this.exportToLink().then(function(url) {
      var attrsString;
      attrsString = 'frameborder=\"0\" width=\"100%\" height=\"100%\" allowfullscreen';
      return "<iframe src=\"" + url + "\" " + attrsString + "></iframe>";
    });
  };

  NMAExportService.prototype.createHtmlPrintout = function() {
    var comparatorId, comparatorTableMode, comparisons, data, denominator, doc, explanations, interventionComparisonPairs, interventions, nmaComponent, outcomes, outcomesFromStore, outcomesToPass, printoutHTML, props, question, selectedInterventionIds, selectedInterventions, selectedOutcomeIds, spliceIdx, spliceTag, tempContainer, transposed, vizConfig, _ref2;
    outcomesFromStore = alt.stores.NMAVizStore.getOutcomes();
    question = alt.stores.NMAVizStore.getQuestion();
    vizConfig = alt.stores.NMAVizStore.getVizConfig().toJS();
    comparatorId = vizConfig.comparatorId, comparatorTableMode = vizConfig.comparatorTableMode, denominator = vizConfig.denominator, selectedInterventionIds = vizConfig.selectedInterventionIds, selectedOutcomeIds = vizConfig.selectedOutcomeIds, transposed = vizConfig.transposed, interventionComparisonPairs = vizConfig.interventionComparisonPairs;
    _ref2 = gdtDataToNmaData(question, outcomesFromStore), interventions = _ref2.interventions, comparisons = _ref2.comparisons, outcomes = _ref2.outcomes, explanations = _ref2.explanations;
    outcomesToPass = outcomes.filter(function(outcome) {
      return selectedOutcomeIds.includes(outcome.id);
    });
    selectedInterventions = interventions.filter(function(intervention) {
      return selectedInterventionIds.includes(intervention.id);
    });
    data = nmaDataToVizData(interventions, selectedInterventions, interventionComparisonPairs, comparisons, comparatorId, comparatorTableMode);
    props = {
      comparatorTableMode: comparatorTableMode,
      data: data,
      expandedRows: [],
      explanations: explanations,
      i18nInstance: i18next,
      outcomes: outcomesToPass,
      showCoeInsufficientLabel: mediator.services.switches.isServerSwitchOn('acpFeatures'),
      tableOrder: vizConfig.tableOrder,
      transposed: transposed,
      thresholdType: question.get('thresholdOptions')
    };
    tempContainer = createPrintoutContainer();
    nmaComponent = React.createElement(NmaTablePrintout, {
      props: props,
      settings: _.extend(vizConfig, {
        renderMode: 'printout',
        outcomes: outcomesToPass
      })
    });
    ReactDOM.render(nmaComponent, tempContainer);
    $(tempContainer).find('button').each(function(_idx, el) {
      return removeHTMLNode(el);
    });
    $(tempContainer).find('.p-datatable-reorderablerow-handle').each(function(_idx, el) {
      return removeHTMLNode(el);
    });
    spliceTag = '<div id="page-container">';
    printoutHTML = printout_template({
      orientation: 'landscape',
      margins: {}
    }, {});
    spliceIdx = printoutHTML.indexOf(spliceTag) + spliceTag.length;
    doc = [printoutHTML.slice(0, spliceIdx), tempContainer.innerHTML, printoutHTML.slice(spliceIdx)].join('');
    return doc;
  };

  NMAExportService.prototype.exportToFile = function(exportFormat) {
    var fileName, question;
    question = alt.stores.NMAVizStore.getQuestion();
    fileName = "" + (question.get('question').substring(0, 100));
    return lift(this.createHtmlPrintout)().then(function(content) {
      return exportToFile(exportFormat, content, {
        fileName: fileName
      });
    }).then(function() {
      return mediator.dialogs.success({
        message: $.t('projects:export_dialog.table_export_successful', {
          'tablename': question.get('question')
        }),
        ms: 10000,
        closeBtn: true
      });
    })["catch"](function(reason) {
      if (reason !== 'cancelled') {
        return mediator.dialogs.error(reason);
      }
    });
  };

  return NMAExportService;

})();
